import { styled } from "styled-components";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  padding: ${({ theme }) => theme.spacing[5]};
  border: 1px solid ${({ theme }) => theme.colors.border.weak};
`;
